import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';
import { TimeWindow } from 'anchor-shared/lib/model/interface/vesselAvailabilityInterfaces';
import { ConstantMan } from '../../../../../../../../../../core/services/constantMan';

@Component({
  selector: 'app-offering-start-times',
  templateUrl: './offering-start-times.component.html',
  styleUrls: ['./offering-start-times.component.scss'],
})
export class OfferingStartTimesComponent implements OnInit {
  openAvailability: boolean;
  times: string[] = ConstantMan.timeSelections;
  openAvailTimes: TimeWindow = {
    startTime: this.times[0],
    endTime: this.times[this.times.length - 1],
  };

  @Input() productOffering: BehaviorSubject<Partial<ProductOffering>>;

  constructor() {}

  ngOnInit() {
    this.setInitialTimeValues();
  }

  disableInvalidTimes(timePosition: 'first' | 'last', time: string): boolean {
    if (timePosition === 'first') {
      return (
        this.times.indexOf(this.openAvailTimes.endTime) <=
        this.times.indexOf(time)
      );
    } else {
      return (
        this.times.indexOf(this.openAvailTimes.startTime) >=
        this.times.indexOf(time)
      );
    }
  }

  changeTimeWindow() {
    if (this.openAvailability) {
      this.productOffering.next({
        ...this.productOffering.value,
        openAvailability: true,
        openAvailabilityStartTime: this.openAvailTimes.startTime,
        openAvailabilityEndTime: this.openAvailTimes.endTime,
        customAvailability: false,
      });
    } else {
      this.productOffering.next({
        ...this.productOffering.value,
        openAvailability: false,
        openAvailabilityStartTime: null,
        openAvailabilityEndTime: null,
        customAvailability: true,
      });
    }
  }

  private setInitialTimeValues() {
    if (
      this.productOffering.value &&
      (this.productOffering.value.openAvailability ||
        this.productOffering.value.customAvailability)
    ) {
      this.openAvailability = this.productOffering.value.openAvailability;
      if (this.productOffering.value.openAvailabilityStartTime) {
        this.openAvailTimes.startTime =
          this.productOffering.value.openAvailabilityStartTime;
        this.openAvailTimes.endTime =
          this.productOffering.value.openAvailabilityEndTime;
      }
    } else {
      this.openAvailability = true;
      this.productOffering.next({
        ...this.productOffering.value,
        openAvailability: true,
        openAvailabilityStartTime: this.openAvailTimes.startTime,
        openAvailabilityEndTime: this.openAvailTimes.endTime,
        customAvailability: false,
      });
    }
  }
}
